export default "__VITE_ASSET__BKdi2oX9__"